import { useEffect } from 'react';

const useAdminSessionCheck = () => {
  useEffect(() => {
    // Check if user navigated from admin to main site
    const checkAndLogoutAdmin = async () => {
      const currentPath = window.location.pathname;
      
      // Only check on main site (root path)
      if (currentPath === '/') {
        try {
          // Check if admin session exists
          const response = await fetch('/api/admin/status', { 
            credentials: 'include' 
          });
          const data = await response.json();
          
          // If admin is logged in, logout
          if (data.loggedIn) {
            await fetch('/api/admin/logout', { 
              method: 'POST', 
              credentials: 'include' 
            });
          }
        } catch (error) {
          // Silently handle errors
          console.log('Admin session check failed:', error);
        }
      }
    };

    checkAndLogoutAdmin();
  }, []);
};

export default useAdminSessionCheck;